export default __webpack_public_path__ + "static/media/AmySquare.fcb63813.jpg";